module.exports = __webpack_public_path__ + "static/media/atom.29627643.svg";